module.exports = function($) {
    class Quizz {

        constructor(){
            /**
             *
             * @type {{number, values}}
             */
            this.Quizz_settings = (typeof communale_quizz != 'undefined')? communale_quizz : {};

            /**
             *
             * @type {{number: number, values: {}}}
             */
            this.Quizz = {
                score: 0,
                number: 0,
                values: {},
                results: {},
                current: '',
                status: '',
                correct_answer: 0,
                total: 10
            };

            this.LetzvoteCommunales = (typeof LetzvoteCommunales != 'undefined')? LetzvoteCommunales : {};

            this.init();

        }

        clear_all(){
            this.Quizz = {
                score: 0,
                number: 0,
                values: {},
                results: {},
                current: '',
                status: '',
                correct_answer: 0
            };

            this.LetzvoteCommunales.score = 0;
            this.LetzvoteCommunales.trials = {
                bulletinVote: 0,
                quizz: 0,
                dragandrop: 0
            };
            // this.LetzvoteCommunales.trials.bulletinVote = 0;
            // this.LetzvoteCommunales.trials.quizz = 0;
            // this.LetzvoteCommunales.trials.dragandrop = 0;
            this.LetzvoteCommunales.number = 0;

            sessionStorage.setItem('CommunalesQuizz', JSON.stringify(this.Quizz) );
            sessionStorage.setItem('LetzvoteCommunales', JSON.stringify(this.LetzvoteCommunales) );
            $('[data-group="pratique"]').removeClass('active');
            $('#pratique--1').addClass('active');
            $('.quizz-items .drawing').removeAttr('style');
            $('.quizz-items .drawing .bubble').addClass('d-none');
            this.quizz_resolve();
        }

        load(){
            let s = sessionStorage.getItem('LetzvoteCommunales');
            if( s ){
                this.LetzvoteCommunales = JSON.parse(s);
            }
        }

        init(){
            this.Container = $('.page-template-tpl-communales .block-pratique--quizz');

            if( this.Container.length == 0 ){
                return;
            }

            this.load();

            let s = sessionStorage.getItem('CommunalesQuizz');
            if( s ){
                this.Quizz = JSON.parse(s);
                this.quizz_markup();
            }

            this.bind();
        }

        bind(){
            const _this = this;

            /**
             * input radio
             */
            this.Container.find('input[type="radio"]').on("change", function(){
                let item = $(this).attr('data-item');
                _this.Quizz.values['question' + item] = [];
                _this.Quizz.values['question' + item].push(parseInt($(this).val()));
                _this.Quizz.results['question' + item] = [];
                _this.Quizz.current = `question${item}`;
                _this.Quizz.number = Object.keys(_this.Quizz.values).length;
                if( !_this.Quizz_settings.values['question' + item].includes(_this.Quizz.values['question' + item][0]) ) {
                    // $(this).closest('.quizz-item').addClass('error').removeClass('success');
                    _this.Quizz.results['question' + item] = 'wrong';
                } else {
                    // $(this).closest('.quizz-item').addClass('success').removeClass('error');
                    _this.Quizz.correct_answer += 1;
                    _this.Quizz.results['question' + item] = 'correct';
                }
                // $(this).closest('.quizz-item').find('input[type="radio"]').prop('disabled', true);
                _this.quizz_resolve();
            });
            /**
             * input checkbox
             */
            $('.block-pratique--quizz .checkbox-confirm').on('click', function(){
                let item = $(this).attr('data-item');
                let _array = [];
                $(this).closest('.quizz-item').find('input[type="checkbox"]:checked').each(function(){
                    _array.push(parseInt($(this).val()));
                });
                _this.Quizz.values['question' + item] = _array;
                _this.Quizz.number = Object.keys(_this.Quizz.values).length;
                _this.Quizz.current = `question${item}`;
                let result = true;
                for( let i in _this.Quizz_settings.values['question' + item]){
                    if( !_this.Quizz.values['question' + item].includes(_this.Quizz_settings.values['question' + item][i]) ) {
                        result = false;
                    }
                }
                if( _this.Quizz.values['question' + item].length != _this.Quizz_settings.values['question' + item].length ){
                    result = false;
                }
                if( result ){
                    _this.Quizz.correct_answer += 1;
                    _this.Quizz.results['question' + item] = 'correct';
                } else {
                    _this.Quizz.results['question' + item] = 'wrong';
                }


                _this.quizz_resolve();
            });
            /**
             * clear
             */
            $('.block-pratique--quizz .clear-quizz').on('click', function (e) {
                e.preventDefault();
                // sessionStorage.removeItem('PratiqueCommunales');
                _this.load();
                _this.LetzvoteCommunales.number -= 1;
                _this.LetzvoteCommunales.score -= _this.LetzvoteCommunales.trials.quizz;
                _this.LetzvoteCommunales.trials.quizz = 0;
                sessionStorage.setItem('LetzvoteCommunales', JSON.stringify(_this.LetzvoteCommunales) );

                _this.Quizz = {
                    score: 0,
                    number: 0,
                    values: {},
                    results: {},
                    current: '',
                    status: '',
                    correct_answer: 0,
                    total: 10
                };
                sessionStorage.setItem('CommunalesQuizz', JSON.stringify(_this.Quizz) );

                $("html, body").animate({ scrollTop: $('.block-pratique').offset().top - 100 }, 400 );
                $('.quizz-items .drawing').removeAttr('style');
                $('.quizz-items .drawing .bubble').addClass('d-none');


                setTimeout(function(){
                    _this.quizz_markup();
                }, 1000);
            })


            $(window).on('resize',function(){
                _this.drawing();
            })
        }

        quizz_markup(){
            /* */
            $('.block-pratique--quizz .quizz-item').removeClass('error').removeClass('success');
            $('.block-pratique--quizz .quizz-item input').prop('disabled', false);
            $('.block-pratique--quizz .quizz-item input').prop('checked', false);

            if( this.Quizz.results[Object.keys(this.Quizz.results)[Object.keys(this.Quizz.results).length - 1]] == "wrong"){
                $('.quizz-items .drawing .success').addClass('d-none');
                $('.quizz-items .drawing .error').removeClass('d-none');
            } else {
                $('.quizz-items .drawing .success').removeClass('d-none');
                $('.quizz-items .drawing .error').addClass('d-none');
            }

            /* */
            for( let i in this.Quizz.results ){
                $('.block-pratique--quizz .quizz-item.' + i + ' input').prop('disabled', true);
                if( this.Quizz.results[i] == "wrong" ){
                    $('.block-pratique--quizz .quizz-item.' + i).addClass('error').removeClass('success');
                } else if( this.Quizz.results[i] == "correct" ){
                    $('.block-pratique--quizz .quizz-item.' + i).removeClass('error').addClass('success');
                }
                for (let j in this.Quizz.values[i]) {
                    let v = this.Quizz.values[i][j];
                    $('.block-pratique--quizz .quizz-item.' + i + ' input[value="'+v+'"]').prop('checked',true);
                }
            }

            /* */
            let x = this.Quizz.score;
            let n = x + " / " + this.Quizz.number;
            this.Container.find('.note').text(n);

            /* */
            if( this.Quizz_settings.number == this.Quizz.number ){
                if( this.Quizz.status == 'failed' ){
                    this.Container.find('.message.alert-success').addClass('d-none');
                    this.Container.find('.message.alert-warning').removeClass('d-none');
                    setTimeout(function(){
                        if( $('[data-group="pratique"].active .block-pratique--quizz .message.alert-warning').length > 0 && $('[data-group="pratique"].active .message.alert-warning').offset().top != 0 ){
                            $("html, body").animate({ scrollTop: $('.block-pratique--quizz .message.alert-warning').offset().top - 100 }, 200 );
                        }
                    }, 800) ;
                } else {
                    $('.block-pratique--quizz .message.alert-success').removeClass('d-none');
                    $('.block-pratique--quizz .message.alert-warning').addClass('d-none');
                        setTimeout(function(){
                            if( $('[data-group="pratique"].active .block-pratique--quizz .message.alert-success').length > 0 && $('[data-group="pratique"].active .message.alert-success').offset().top != 0 ){
                                $("html, body").animate({ scrollTop: $('[data-group="pratique"].active .message.alert-success').offset().top - 100 }, 200 );
                            }
                        }, 800) ;
                }
                $('.score_global').html(this.LetzvoteCommunales.score + " / " + this.LetzvoteCommunales.total);
            } else {
                this.Container.find('.message.alert-success').addClass('d-none');
                this.Container.find('.message.alert-warning').addClass('d-none');
            }

        }

        drawing(){
            let current = this.Quizz.current;
            let topparent = this.Container.find('.quizz-items').offset().top;

            if( !current ){
                this.Container.find('.quizz-items .drawing').css({'top':'0px'});
                return;
            }

            this.Container.find('.quizz-item').css({'margin-top': '0px'});

            if( $(window).width() >= 992 ){
                let height = $(".quizz-item."+current).height() / 2;
                let top = $(".quizz-item."+current).offset().top - topparent + height;
                $('.quizz-items .drawing').css({'top': `${top}px`, 'position': 'absolute'});
            } else {
                if( current != 'question0'){
                    this.Container.find('.drawing').css({'position': 'absolute'});
                    let h = parseFloat(this.Container.find('.drawing').height()) + 60;
                    let t =  parseFloat(this.Container.find('.quizz-item.' + current).offset().top) - parseFloat(topparent);
                    this.Container.find('.quizz-item.' + current).css({'margin-top': h + 'px'});
                    this.Container.find('.drawing').css({'top': t + 'px'});
                } else{
                    this.Container.find('.quizz-items .drawing').css({'top':'0px', 'position': 'relative'});
                }
            }
        }

        quizz_resolve(){

            this.load();

            let current = this.Quizz.current;
            $('.quizz-items .drawing .bubble').addClass('d-none');
            if( current ){
                let topparent = $('.quizz-items').offset().top;
                let height = $(".quizz-item."+current).height() / 2;
                let top = $(".quizz-item."+current).offset().top - topparent + height;
                $('.quizz-items .drawing').css({'top': `${top}px`});
                $(`.quizz-items .drawing .bubble-${current}`).removeClass('d-none');
                this.drawing();
            }

            if( this.Quizz_settings.number == this.Quizz.number ){
                if( this.Quizz.correct_answer >= this.Quizz_settings.number/2 ){
                    this.Quizz.status = 'successful';
                } else {
                    this.Quizz.status = 'failed';
                }
                let score = this.Quizz.correct_answer;
                this.Quizz.score  = score;
                sessionStorage.setItem('CommunalesQuizz', JSON.stringify(this.Quizz) );

                this.LetzvoteCommunales.trials.quizz = score;
                this.LetzvoteCommunales.number += 1;
                this.LetzvoteCommunales.score += score;
                sessionStorage.setItem('LetzvoteCommunales', JSON.stringify(this.LetzvoteCommunales) );
            }



            this.quizz_markup();

        }
    }

    return new Quizz;
}
